import * as React from 'react';

import Tooltip from 'af-components/Tooltip';

import styles from './styles.module.scss';

interface TextGlyph {
	type: 'text';
	value: string;
	tooltip?: string;
}

interface IconGlyph {
	type: 'icon';
	value: string;
	tooltip?: string;
}

interface NodeGlyph {
	type: 'node';
	value: React.ReactNode;
	tooltip?: string;
}

export type GlyphItem = (
	TextGlyph
	| IconGlyph
	| NodeGlyph
);

interface OwnProps {
	glyph: GlyphItem;
}

type Props = OwnProps;

const Glyph: React.FC<Props> = (props) => {
	const { glyph: { type, value, tooltip } } = props;

	const className = `${styles.Glyph} ${styles[type]} ${type === 'icon' ? `icon-${value}` : ''}`;

	const textContent = type === 'text' ? value : null;

	const contentNode = type !== 'node' ? <span className={className}>{textContent}</span> : value;

	if (tooltip) {
		return (
			<Tooltip message={tooltip}>
				{contentNode}
			</Tooltip>
		);
	}

	return contentNode;
};

export default React.memo(Glyph);
